interface HasStatus {
  status: string;
}

interface HasExpiry {
  expiresAt?: string;
}

interface HasTimestamps {
  createdAt: string;
  updatedAt?: string;
  completedAt?: string;
}

export const isExpired = (item: HasExpiry): boolean => {
  if (item.expiresAt && new Date(item.expiresAt) < new Date()) return true;
  return false;
};

export const isActive = (item: HasStatus): boolean => {
  return item.status === "pending" || item.status === "processing";
};

export const isNewComplete = (item: HasStatus & HasTimestamps): boolean => {
  if (item.status !== "complete") return false;
  const completedAt = new Date(item.completedAt || item.updatedAt || item.createdAt);
  const oneHourAgo = new Date(Date.now() - 60 * 60 * 1000);
  return completedAt.getTime() > oneHourAgo.getTime();
};
